import { type ReactNode, forwardRef } from "react";

interface IContainerProps {
  children: ReactNode | ReactNode[];
  className?: string;
}

const Container = forwardRef<HTMLDivElement, IContainerProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={`customContainer mx-auto  ${className}`}
      >
        {children}
      </div>
    );
  },
);

Container.displayName = "Container";

export default Container;
